import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { dateSchema, parseToDateValue } from "@/features/FormCard/utils";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { z } from "zod";

const filterDownloadCenterSchema = z.object({
  user_contains: z.string().optional(),
  created_at_from: z
    .preprocess((val) => parseToDateValue(val), dateSchema)
    .optional(),
  created_at_to: z
    .preprocess((val) => parseToDateValue(val), dateSchema)
    .optional(),
  date_equals: z
    .preprocess((val) => parseToDateValue(val), dateSchema)
    .optional(),
  shortcuts: z
    .preprocess((val) => {
      if (val === "true") return true;
      if (val === "false") return false;
      return undefined;
    }, z.boolean())
    .optional(),
});

export type FilterDownloadCenterSchemaType = z.infer<
  typeof filterDownloadCenterSchema
>;

export function FilterDownloadCenterOPCVM() {
  const { t } = useTranslation();
  const fields = useMemo<Field[]>(
    () => [
      {
        name: "user_contains",
        label: t("download_center.columns.user_name", {
          defaultValue: "Utilisateur",
        }),
        type: "input",
      },
      {
        name: "shortcuts",
        label: "Shortcuts",
        type: "select",
        useTranslation: false,
        options: [
          { value: "true", label: "Avec shortcuts" },
          { value: "false", label: "Sans shortcuts" },
        ],
      },
      {
        name: "date_equals",
        label: t("download_center.columns.reporting_date", {
          defaultValue: "Date du rapport",
        }),
        type: "date",
      },
      {
        name: "created_at_from",
        label: t("download_center.columns.created_at_from", {
          defaultValue: "Date de génération (début)",
        }),
        type: "date",
      },
      {
        name: "created_at_to",
        label: t("download_center.columns.created_at_to", {
          defaultValue: "Date de génération (fin)",
        }),
        type: "date",
      },
    ],
    [t],
  );
  return (
    <FilterTable
      schema={filterDownloadCenterSchema}
      client="a7"
      tableName="a7_opcvm_download_center"
      fields={fields}
      customBuildPath={() => "a7-opcvm/a7_opcvm_download_center"}
    />
  );
}
